// extracted by mini-css-extract-plugin
export var articleCardContainer = "read-also-module--articleCardContainer--3d2ac";
export var articlesContainer = "read-also-module--articlesContainer--5a6f4";
export var carouselButtons = "read-also-module--carouselButtons--9392b";
export var container = "read-also-module--container--f0645";
export var nextButton = "read-also-module--nextButton--e3740";
export var prevButton = "read-also-module--prevButton--d5961";
export var sectionTitle = "read-also-module--sectionTitle--8f45a";